import { utils, writeFile } from 'xlsx';
import { getCuadrillasOnce } from '../services/cuadrillasService';

const HEADERS = ['SERIE MECÁNICA', 'NRO WO', 'FECHA DE ASISTENCIA', 'CUADRILLA', 'OBSERVACIÓN'];

const getCuadrillaLabel = (remito, cuadrillas = []) => {
    const idEntrega = remito?.idCuadrillaEntrega;
    const nameEntrega = remito?.cuadrillaEntrega || '';
    const userEntrega = remito?.usuarioCuadrillaEntrega || '';

    // Buscar cuadrilla en la lista cargada de cuadrillas
    const found = (cuadrillas || []).find(c =>
        (idEntrega != null && String(c.id) === String(idEntrega)) ||
        (nameEntrega && String(c.numero).toLowerCase() === String(nameEntrega).toLowerCase()) ||
        (userEntrega && String(c.usuario).toLowerCase() === String(userEntrega).toLowerCase())
    );

    if (found) {
        const parts = [];
        if (found.codigo) parts.push(found.codigo);
        if (found.numero) parts.push(found.numero);
        if (found.usuario) parts.push(found.usuario);
        if (parts.length > 0) return parts.join(' - ');
    }

    // Si la cuadrilla no se encuentra en la BD, armar con lo que tenga el remito
    const parts = [];
    if (remito?.codigoCuadrillaEntrega) parts.push(remito.codigoCuadrillaEntrega);
    if (nameEntrega) parts.push(nameEntrega);
    if (userEntrega && !nameEntrega.toLowerCase().includes(userEntrega.toLowerCase())) {
        parts.push(userEntrega);
    }
    return parts.length > 0 ? parts.join(' - ') : nameEntrega;
};

const buildRowsFromRemito = (remito, cuadrillas = []) => {
    const cuadrillaOrigen = getCuadrillaLabel(remito, cuadrillas);
    return (remito?.serials || []).map(serial => ({
        'SERIE MECÁNICA': serial?.id || '',
        'NRO WO': serial?.nroWO || '',
        'FECHA DE ASISTENCIA': serial?.fechaAsistencia || '',
        'CUADRILLA': cuadrillaOrigen,
        'OBSERVACIÓN': serial?.observaciones || '',
    }));
};

export const downloadDevolucionExcel = async (remito, cuadrillasInput = null) => {
    let cuadrillas = cuadrillasInput;
    if (!cuadrillas || cuadrillas.length === 0) {
        await getCuadrillasOnce((data) => { cuadrillas = data; }, { soloActivas: false });
    }

    const rows = buildRowsFromRemito(remito, cuadrillas);

    const ws = utils.json_to_sheet(rows, { header: HEADERS });
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Devolucion');

    const fileName = `devolucion_${remito?.id ?? 'remito'}.xlsx`;
    writeFile(wb, fileName);
};

export const downloadDevolucionExcelMultiple = async (remitos, fileName, cuadrillasInput = null) => {
    let cuadrillas = cuadrillasInput;
    if (!cuadrillas || cuadrillas.length === 0) {
        await getCuadrillasOnce((data) => { cuadrillas = data; }, { soloActivas: false });
    }

    const rows = (remitos || []).flatMap(r => buildRowsFromRemito(r, cuadrillas));

    const ws = utils.json_to_sheet(rows, { header: HEADERS });
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Devoluciones');

    writeFile(wb, fileName || 'devoluciones.xlsx');
    return rows.length;
};
